import styled from 'styled-components';

export const BoxHeading = styled.h4`
  font-family: 'Barlow Condensed Extra Bold', sans-serif;
  font-size: 40px;
  font-weight: 800;
  line-height: 43px;
  text-transform: uppercase;
  margin: 30px 0 10px;
  color: ${(props) => props.color};
`;
